import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Without the prefix, Bootstrap class names are parsed as Tailwind utilities
// and silently deduped.
const twMerge = extendTailwindMerge({ prefix: 'tw' });

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
